import {useRoutes} from 'react-router';
import Home from './pages/Home.js';
import Meeting from './pages/Meeting.js';
import NumerologyCalculator from './pages/NumerologyCalculator.js';
import NotFound from './pages/NotFound.js';
import TarotmailCustomer from './pages/tarotmail/TarotmailCustomer.js';
import TarotmailStudent from './pages/tarotmail/TarotmailStudent.js';
import Counseling from './pages/Counseling.js';
import Services from './pages/Services.js';
import StudentArea from './pages/StudentArea.js';
import Contact from './pages/Contact.js';
import TarotSpread from './pages/TarotSpread.js';
import PrivateLessons from './pages/PrivateLessons.js';
import Workshops from './pages/Workshops.js';
import TarotSpreadPage from './pages/TarotSpreadPage.js';
import Webrtc from './pages/Webrtc.js';
import WebrtcParticipant from './pages/WebrtcParticipant.js';
import AdminUsers from './pages/AdminUsers.js';
import TarotmailCustomerSimona from './pages/tarotmail/TarotmailCustomerSimona.js';
import Terms from './pages/legal/Terms.js';
import PrivacyPolicy from './pages/legal/PrivacyPolicy.js';
import Accessibility from './pages/legal/Accessibility.js';
import AdminMetrics from './pages/AdminMetrics.js';
import PasswordReset from './pages/PasswordReset.js';
import TarotmailLanding from './pages/tarotmail/TarotmailLanding.js';
import TarakoHost from './pages/tarako/TarakoHost.js';
import TarotmailPostPurchase from './pages/tarotmail/TarotmailPostPurchase.js';
import UserSettings from './pages/UserSettings.js';
import TarotmailPurchase from './pages/tarotmail/TarotmailPurchase.js';
import EmailUnsubscribe from './pages/EmailUnsubscribe.js';
import TarotmailSagieAddRound from './pages/tarotmail/TarotmailSagieAddRound.js';
import AdminPurchases from './pages/AdminPurchases.js';
import TarotmailSimonaAddRound from './pages/tarotmail/TarotmailSimonaAddRound.js';
import TarotmailSimonaAddRoundConfirm from './pages/tarotmail/TarotmailSimonaAddRoundConfirm.js';
import BlogPost from './pages/blog/BlogPost.js';
import Blog from './pages/blog/Blog.js';
import ProductPurchaseComplete from './pages/ProductPurchaseComplete.js';
import CleansingWorkshopLanding from './pages/CleansingWorkshopLanding.js';

// TODO: IMPLEMENT REACT LAZY
export const useSiteRoutes = ()=>useRoutes([
    {path: '/', Component: Home},
    {path: '/services', Component: Services},
    {path: '/contact', Component: Contact},
    {path: '/meeting', Component: Meeting},
    {path: '/counseling', Component: Counseling},
    {path: '/private_lessons', Component: PrivateLessons},
    {path: '/workshops', Component: Workshops},
    {path: '/numerology_calculator', Component: NumerologyCalculator},
    {path: '/student_area', Component: StudentArea},
    {path: '/cleansing_workshop', Component: CleansingWorkshopLanding},
    {path: '/product_purchase_complete', Component: ProductPurchaseComplete},
    {path: '/tarotmail/student', Component: TarotmailStudent},
    {path: '/tarotmail', Component: TarotmailCustomer},
    {path: '/tarotmail/simona', Component: TarotmailCustomerSimona},
    {path: '/tarotmail/simona/add_round', Component: TarotmailSimonaAddRound},
    {path: '/tarotmail/simona/add_round_confirm', Component: TarotmailSimonaAddRoundConfirm},
    {path: '/tarotmail/purchase', Component: TarotmailPurchase},
    {path: '/tarotmail/post_purchase', Component: TarotmailPostPurchase},
    {path: '/tarotmail/sagie/add_round', Component: TarotmailSagieAddRound},
    {path: '/tarotmail-lp', Component: TarotmailLanding},
    {path: '/tarotspread', Component: TarotSpread},
    {path: '/tarot-spread', Component: TarotSpreadPage},
    {path: '/admin/users', Component: AdminUsers},
    {path: '/admin/metrics', Component: AdminMetrics},
    {path: '/admin/purchases', Component: AdminPurchases},
    {path: '/tarako/host', Component: TarakoHost},
    {path: '/webrtc_host', Component: Webrtc},
    {path: '/webrtc_participant', Component: WebrtcParticipant},
    {path: '/terms', Component: Terms},
    {path: '/privacy-policy', Component: PrivacyPolicy},
    {path: '/accessibility', Component: Accessibility},
    {path: '/password_reset', Component: PasswordReset},
    {path: '/user_settings', Component: UserSettings},
    {path: '/email_unsubscribe', Component: EmailUnsubscribe},
    {path: '/blog/post/:slug', Component: BlogPost},
    {path: '/blog', Component: Blog},
    {path: '*', Component: NotFound},
]);
